module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '', __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
with (obj) {
__p += '<!-- 自定义 select 面板 -->\r\n<ul class="my-select-list">\r\n    ';
 for(var i = 0; i < options.length; i++){ var option = options[i]; ;
__p += '\r\n    <li data-value="' +
((__t = ( option.value )) == null ? '' : __t) +
'" class="' +
((__t = ( option.attr )) == null ? '' : __t) +
'" >' +
((__t = ( option.text )) == null ? '' : __t) +
'</li>\r\n    ';
 } ;
__p += '\r\n</ul>';

}
return __p
}


//////////////////
// WEBPACK FOOTER
// ./src/common/select/templates/select.ejs
// module id = 33
// module chunks = 0 1 2 3 4 5 6 7 8 9 11 12